import { REGIONS, ENVS, Colors } from '@adsk/bim360-matrix-react-helpers/es/consts';

export const MEETINGS_ENV_CONFIG_KEYS = {
  MEETINGS_BE: 'MEETINGS_BE',
  MEETINGS_FE: 'MEETINGS_FE'
};

const US_CONFIG = {
  [ENVS.DEV]: {
    [MEETINGS_ENV_CONFIG_KEYS.MEETINGS_BE]:
      'https://developer-stg.api.autodesk.com/bim360/meetings-qa',
    [MEETINGS_ENV_CONFIG_KEYS.MEETINGS_FE]: 'https://meetings.b360-qa.autodesk.com'
  },
  [ENVS.QA]: {
    [MEETINGS_ENV_CONFIG_KEYS.MEETINGS_BE]:
      'https://developer-stg.api.autodesk.com/bim360/meetings-qa',
    [MEETINGS_ENV_CONFIG_KEYS.MEETINGS_FE]: 'https://meetings.b360-qa.autodesk.com'
  },
  [ENVS.STAGING]: {
    [MEETINGS_ENV_CONFIG_KEYS.MEETINGS_BE]:
      'https://developer-stg.api.autodesk.com/bim360/meetings',
    [MEETINGS_ENV_CONFIG_KEYS.MEETINGS_FE]: 'https://meetings.b360-staging.autodesk.com'
  },
  [ENVS.PROD]: {
    [MEETINGS_ENV_CONFIG_KEYS.MEETINGS_BE]: 'https://developer.api.autodesk.com/bim360/meetings',
    [MEETINGS_ENV_CONFIG_KEYS.MEETINGS_FE]: 'https://meetings.b360.autodesk.com'
  }
};

export const ENV_CONFIGS = {
  [REGIONS.US]: US_CONFIG,
  [REGIONS.EMEA]: {
    [ENVS.QA]: US_CONFIG[ENVS.QA],
    [ENVS.STAGING]: {
      [MEETINGS_ENV_CONFIG_KEYS.MEETINGS_BE]:
        US_CONFIG[ENVS.STAGING][MEETINGS_ENV_CONFIG_KEYS.MEETINGS_BE],
      [MEETINGS_ENV_CONFIG_KEYS.MEETINGS_FE]: 'https://meetings.b360-staging.eu.autodesk.com'
    },
    [ENVS.PROD]: {
      [MEETINGS_ENV_CONFIG_KEYS.MEETINGS_BE]:
        US_CONFIG[ENVS.PROD][MEETINGS_ENV_CONFIG_KEYS.MEETINGS_BE],
      [MEETINGS_ENV_CONFIG_KEYS.MEETINGS_FE]: 'https://meetings.b360.eu.autodesk.com'
    }
  }
};

export const Statuses = {
  OPEN: 'open',
  CLOSED: 'closed'
};

export const statusColorMapping = {
  [Statuses.OPEN]: Colors.YELLOW,
  [Statuses.CLOSED]: Colors.GRAY
};
